import { styled } from '@mui/material';
import Button, { CustomButtonProps } from '@/components/Button';
import { ComponentType } from 'react';

type Props = {
  colors?: {
    default?: string,
    hovered?: string,
  }
};

const PanelButton: ComponentType<CustomButtonProps & Props> = styled<ComponentType<CustomButtonProps & Props>>(Button)(
  ({ colors }) => ({
    padding: 0,
    minWidth: '32px',
    width: '32px',
    height: '32px',
    ['& svg']: {
      color: colors?.default || '#6B778C',
    },

    ['&:hover']: {
      color: 'currentColor',
      backgroundColor: 'unset',
    },

    ['&:hover svg']: {
      color: colors?.hovered || '#091E42',
    }

  })
);

export default PanelButton;